import { render, staticRenderFns } from "./appointRule.vue?vue&type=template&id=a6b57dac&scoped=true"
import script from "./appointRule.vue?vue&type=script&lang=js"
export * from "./appointRule.vue?vue&type=script&lang=js"
import style0 from "./appointRule.vue?vue&type=style&index=0&id=a6b57dac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6b57dac",
  null
  
)

export default component.exports